import React, { useCallback, useEffect, useState } from 'react';
import { View, Heading, colors, Text } from '@fairygodboss/ui';
import window from 'global/window';
import LinesEllipsis from 'react-lines-ellipsis';
import * as Cookies from 'js-cookie';
import Pixel, {
    EmitMetric,
} from '../../../../../Analytics/VisibilityPixel/VisibilityPixel';
import { REGWALL_RECENT_DISCUSSION } from '../../../../../../contexts/Includes/pageContextHelpers';
import {
    getTitle,
    linkify,
    trimFront,
} from '../../../../../../utilities/ui_utilities';

export const ContentCard = ({ article, url, hash, type }) => {
    const { title, description, likes, commentCount } = article;

    let trueDescription = trimFront(description);
    let trueTitle = title;
    if (title === '' || !title) {
        const parts = getTitle(description);
        trueTitle = parts.title;
        trueDescription = parts.description;
    }
    const info = { title: trueTitle, body: trueDescription };
    const [imgKey, setImgKey] = useState(1);
    const [maxLines, setMaxLines] = useState('7');

    const handleResize = useCallback(() => {
        if (window.innerWidth < 905 && maxLines !== '6') {
            setMaxLines('6');
        } else if (maxLines !== '7' && window.innerWidth >= 905) {
            setMaxLines('7');
        }
    }, [window.innerWidth]);

    useEffect(() => {
        handleResize();
    }, [handleResize]);

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [handleResize]);

    const onDiscussionLinkClick = () => {
        EmitMetric({
            misc_event_type: 'recent-post-click',
            click: 1,
            community_content_location: 'single',
            community_content_key: `${type}-${hash}`,
        });
        Cookies.set('EVENT-LOGIN-TRIGGER', 'recent-discussion-registration', {
            expires: 1095,
        });
        window.open(`${url}?regwall=${REGWALL_RECENT_DISCUSSION}`, '_self');
    };

    /*
    on resize force Responsive image component to rerender by setting a new key
    */
    const windowResize = useCallback(() => {
        const randomNumber = Math.floor(Math.random() * 1001);
        setImgKey(randomNumber + 1);
    }, []);

    useEffect(() => {
        windowResize();
        window.addEventListener('resize', windowResize, { passive: true });
        return () => {
            window.removeEventListener('resize', windowResize);
        };
    }, [windowResize]);

    const commentText = commentCount === 1 ? 'Comment' : 'Comments';
    const likeText = likes === 1 ? 'Like' : 'Likes';

    return (
        <View
            flex={{ _: '0 0 100%', sm: '0 0 50%', md: '0 0 33.333333%' }}
            px={{ _: '0px', sm: '8px', md: '12px' }}
            mt={{ _: '0px', sm: '14px', md: '43px', lg: '43px' }}
            height={{ _: '300px', sm: '285px', md: '329px' }}
            minHeight={{ _: '300px', sm: '285px', md: '329px' }}
            width={{ _: '324px', sm: '276px', md: '368px' }}
        >
            <Pixel
                metrics={{
                    misc_event_type: 'recent-post-impression',
                    impression: 1,
                    community_content_key: `${type}-${hash}`,
                    community_content_location: 'single',
                }}
            />
            <View
                borderRadius="5px"
                as="span"
                css={{
                    cursor: 'pointer',
                }}
                onClick={onDiscussionLinkClick}
                height={{ _: '300px', sm: '285px', md: '329px' }}
            >
                <View
                    overflow="hidden"
                    css={{
                        ':hover': {
                            boxShadow: '0 12px 32px rgb(53 53 53 / 24%)',
                        },
                    }}
                    borderRadius="5px"
                    backgroundColor="#FFFFFF"
                    height={{ _: 'inherit', sm: '100%' }}
                    key={`${hash}-${imgKey}`}
                >
                    <Heading
                        variant={{
                            _: 'headingXs',
                            md: 'headingSm',
                        }}
                        color={colors.neutral[100]}
                        borderRadius="0 0 5px 5px"
                        height={{ _: '48px', md: '60px' }}
                        mx="16px"
                        mt="16px"
                        mb={{ _: '8px', md: '16px' }}
                        fontWeight="600"
                        css={{
                            overflow: 'hidden',
                            display: '-webkit-box',
                            textOverflow: 'ellipsis',
                            '-webkit-line-clamp': '2',
                            '-webkit-box-orient': 'vertical',
                            whiteSpace: 'pre-line',
                        }}
                    >
                        {info.title}
                    </Heading>
                    <View
                        height={{ _: '162px', sm: '163px', md: '187px' }}
                        mx="16px"
                        mb="16px"
                        className="clamp"
                        lineHeight="26px"
                        fontWeight="400"
                        css={{
                            a: {
                                textDecoration: 'underline !important',
                                ':visited': {
                                    color: `${colors.secondary[70]} !important`,
                                },
                            },
                            color: `${colors.neutral[100]} !important`,
                            overflow: 'hidden',
                            '-webkit-line-clamp': '6',
                            '-webkit-box-orient': 'vertical',
                            maxWidth: '100%',
                            textOverflow: 'ellipsis',
                            fontSize: '16px !important',
                            whiteSpace: 'pre-line',
                            p: {
                                lineHeight: '26px',
                            },
                        }}
                    >
                        <LinesEllipsis text={info.body} maxLine={maxLines} />
                    </View>

                    <View

                        css={{
                            color: `${colors.neutral[80]}`,
                            lineHeight: '18px !important',
                            fontSize: '14px !important',
                            fontWeight: '400 !important',
                            span: {
                                ':hover': {
                                    textDecoration: 'underline',
                                    color: colors.neutral[100],
                                },
                            },
                        }}
                        mx="16px"
                        mb={{ xs: '16px', sm: '16px' }}
                    >
                        <Text
                            pt="8px"
                            as="span"
                            margin="0"
                            textAlign="left"
                            variant="labelMd"
                        >
                            {`${likes} ${likeText}`}
                        </Text>
                        {'   •  '}
                        <Text
                            pt="8px"
                            as="span"
                            margin="0"
                            textAlign="left"
                            variant="labelMd"
                        >
                            {`${commentCount} ${commentText}`}
                        </Text>
                    </View>
                </View>
            </View>
        </View>
    );
};
